// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

import {FACTION_SKINS_AQUARS} from './aquars';
import {FACTION_SKINS_BEASTMEN} from './beastmen';
import {FACTION_SKINS_CELECTIALS} from './celectials';
import {FACTION_SKINS_DARK_ELVES} from './dark_elves';
import {FACTION_SKINS_DEMONS} from './demons';
import {FACTION_SKINS_DOPPLERS} from './dopplers';
import {FACTION_SKINS_DRAGONS} from './dragons';
import {FACTION_SKINS_DWARVES} from './dwarves';
import {FACTION_SKINS_ELEMENTALS} from './elementals';
import {FACTION_SKINS_ELVES} from './elves';
import {FACTION_SKINS_ENTS} from './ents';
import {FACTION_SKINS_FENIX} from './fenix';
import {FACTION_SKINS_GIANTS} from './giants';
import {FACTION_SKINS_GOBLINS} from './goblins';
import {FACTION_SKINS_GREMLINS} from './gremlins';
import {FACTION_SKINS_HUMANS} from './humans';
import {FACTION_SKINS_INSECTOIDS} from './insectoids';
import {FACTION_SKINS_LEPRECHAUNS} from './leprechauns';
import {FACTION_SKINS_MUSHROOM_PEOPLE} from './mushroom_people';
import {FACTION_SKINS_ORCS} from './orcs';
import {FACTION_SKINS_RATMEN} from './ratmen';
import {FACTION_SKINS_SUCCUBES} from './succubes';
import {FACTION_SKINS_UNDEAD} from './undead';
import {FACTION_SKINS_VENTORY} from './ventory';
import {FACTION_SKINS_WIZARDS} from "./wizards";
import {FACTION_SKINS_ENLIGHTENED} from "./enlightened";
import {FACTION_SKINS_TECHNODWARVES} from "./technodwarves";
import {FACTION_SKINS_SPIRITS} from "./spirits";

export const ALL_FACTION_SKINS = [
  ...FACTION_SKINS_AQUARS,
  ...FACTION_SKINS_BEASTMEN,
  ...FACTION_SKINS_CELECTIALS,
  ...FACTION_SKINS_DARK_ELVES,
  ...FACTION_SKINS_DEMONS,
  ...FACTION_SKINS_DOPPLERS,
  ...FACTION_SKINS_DRAGONS,
  ...FACTION_SKINS_DWARVES,
  ...FACTION_SKINS_ELEMENTALS,
  ...FACTION_SKINS_ELVES,
  ...FACTION_SKINS_ENLIGHTENED,
  ...FACTION_SKINS_ENTS,
  ...FACTION_SKINS_FENIX,
  ...FACTION_SKINS_GIANTS,
  ...FACTION_SKINS_GOBLINS,
  ...FACTION_SKINS_GREMLINS,
  ...FACTION_SKINS_HUMANS,
  ...FACTION_SKINS_INSECTOIDS,
  ...FACTION_SKINS_LEPRECHAUNS,
  ...FACTION_SKINS_MUSHROOM_PEOPLE,
  ...FACTION_SKINS_ORCS,
  ...FACTION_SKINS_RATMEN,
  ...FACTION_SKINS_SPIRITS,
  ...FACTION_SKINS_SUCCUBES,
  ...FACTION_SKINS_TECHNODWARVES,
  ...FACTION_SKINS_UNDEAD,
  ...FACTION_SKINS_VENTORY,
  ...FACTION_SKINS_WIZARDS,
];

export function getFactionSkinConfig(skinId) {
  return ALL_FACTION_SKINS.find((config) => config.id === skinId);
}

export function getFactionSkinImagePath(skinId) {
  if (!skinId) return '';
  return `/img/factions/skins/${skinId}.jpg`;
}

export function getFactionSkinIconPath(skinId) {
  if (!skinId) {
    return '/img/other/strategikon_bust.png';
  }
  return `/img/factions/skins_icons/skin_icon_${skinId}.jpg`;
}

export function isFactionSkinVisible(skin, ownedSkinIds) {
  if (!skin.notObtainable) return true;
  if (!ownedSkinIds) return false;
  if (Array.isArray(ownedSkinIds)) {
    return ownedSkinIds.includes(skin.id);
  }
  return ownedSkinIds.has(skin.id);
}
